<template>
  <div class="windows zeromp">
    <div class="mycontainer zeromp">
      <div class="tile parent-contanier zeromp">
        <div class="tile is-ancestor box is-2 zeromp">
          <sidebar :cargo="this.$route.meta.cargo" />
        </div>

        <div class="tile is-ancestor is-vertical box is-12 zeromp">
          <div class="tile is-parent is-12 zeromp">
            <article class="tile is-child zeromp">
              <div class="content zeromp">
                <internnavbar />
              </div>
            </article>
          </div>
          <div class="tile is-vertical is-12 internbackground">
            <div class="tile is-parent is-vertical">
              <div class="tile is-child">
                <p class="indextitle">Corretores</p>
                <b-button
                  @click="showFiltersBar"
                  class="lupabusca"
                >
                  <i class="fas fa-search dp-none"></i>
                </b-button>
                <b-button
                  @click="hideFiltersBar"
                  class="lupabusca closeLupa"
                >
                  <i class="fas fa-times dp-none"></i>
                </b-button>

                <div class>
                  <div class id="tabela-corretors">
                    <b-button
                      class="is-white"
                      tag="router-link"
                      to="/admin/corretor/create"
                      type="is-link"
                    >ADICIONAR NOVO CORRETOR</b-button>

                    <b-table
                      :data="isEmpty ? [] : corretors"
                      :paginated="true"
                      :per-page="10"
                      :hoverable="true"
                    >
                      <template slot-scope="props">
                        <!-- colunas-->

                      
                          <b-table-column
                            field="name"
                            label="Nome Completo"
                            searchable
                          >{{ props.row.name }} {{ props.row.sobrenome }}</b-table-column>
                          <b-table-column
                            field="email"
                            label="E-mail"
                            searchable
                          >{{ props.row.email }}</b-table-column>
                          <b-table-column
                            field="vinculo"
                            label="Vinculo"
                            searchable
                          >{{ props.row.vinculo }}</b-table-column>
                          <b-table-column label="Créditos a receber">{{ props.row.receber }}</b-table-column>
                          <b-table-column label="Créditos pago">{{ props.row.pago }}</b-table-column>

                          <b-table-column field="actions" class="actionsHover" centered>
                            <!-- Creditos -->
                            <b-tooltip label="Pagar Créditos" position="is-top" type="is-dark">
                              <button
                                class="button is-primary is-round"
                                id="creditos"
                                @click="credito.corretor_id = props.row.id, isCardModal2Active = true"
                              >
                                <span class="fas fa-coins is-round icon-awesome"></span>
                              </button>
                            </b-tooltip>

                            <!-- detalhes -->
                            <b-tooltip label="Detalhes" position="is-top" type="is-dark">
                              <button
                                class="button is-primary is-round"
                                id="info"
                                @click="info(props.row.id), isCardModalActive = true"
                              >
                                <b-icon icon="eye"></b-icon>
                              </button>
                            </b-tooltip>

                            <!-- editar -->
                            <b-tooltip label="Editar corretor" position="is-top" type="is-dark">
                              <router-link
                                :to="{ name: 'admin/corretor/update', params: { uuid: props.row.id }}"
                              >
                                <button class="button is-primary is-round" id="edit">
                                  <b-icon icon="pencil"></b-icon>
                                </button>
                              </router-link>
                            </b-tooltip>

                            <!-- deletar -->
                            <b-tooltip label="Deletar corretor" position="is-top" type="is-dark">
                              <button
                                class="button is-primary is-round"
                                id="delete"
                                @click="deletar(props.row.id)"
                              >
                                <b-icon icon="delete-outline"></b-icon>
                              </button>
                            </b-tooltip>
                          </b-table-column>
                      </template>
                      <template slot="empty">
                        <Empty :messageEmpty="'Nada aqui.'" />
                      </template>
                                            <template slot="loading">
                        <Empty :messageEmpty="'Carregando...'" />
                      </template>
                    </b-table>
                  </div>
                </div>

                <b-modal :active.sync="isCardModalActive">
                  <CorretorBase :usuario="corretor" />
                </b-modal>

                <b-modal :active.sync="isCardModal2Active" style="width=729; height=425;">
                  <div class="card">
                    <div class="card-content">
                      <div class="content">
                        <h1>Pagar Crédito</h1>
                        <h3>{{ corretor.name }}</h3>

                        <b-field label="creditos">
                          <b-input
                            type="number"
                            v-model="credito['rm']"
                            v-validate="'required'"
                            name="creditos"
                          ></b-input>
                        </b-field>

                        <button @click="remover()" class="button is-primary">Pagar</button>
                      </div>
                    </div>
                  </div>
                </b-modal>
              </div>
              <internfooter />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CorretorService from "@/services/CorretorService";
import CreditoService from "@/services/CreditoService";
import internnavbar from "@/components/Navbars/InternNav";
import internfooter from "@/components/Footers/InternFooter";
import sidebar from "@/components/SideBar/SideBar";
import CorretorBase from "@/components/Perfil/CorretorBase";
import Empty from "@/components/Tables/Empty";

export default {
  data() {
    return {
      corretors: [],
      corretor: [],
      isEmpty: false,
      loading: true,
      isCardModalActive: false,
      isCardModal2Active: false,
      credito: {
        corretor_id: "",
        add: "",
        rm: ""
      }
    };
  },
  components: {
    internnavbar: internnavbar,
    internfooter: internfooter,
    sidebar: sidebar,
    CorretorBase: CorretorBase,
    Empty: Empty
  },

  created() {
    this.loading = true;
    CorretorService.Index().then(result => {
      this.corretors = result.data;
      this.loading = false;
    });
  },
  methods: {
    remover() {
      if (confirm("você realmente deseja remover creditos desse corretor?")) {
        CreditoService.RmCorretor(this.credito.corretor_id, this.credito)
          .then(() => {
            this.$buefy.toast.open({
              duration: 5000,
              message: "adicionado com sucesso!",
              position: "is-top-right",
              type: "is-success"
            });
          })
          .catch(() => {})
          .finally(() => {});
      }
      this.isCardModal2Active = false;
    },

    deletar(cuuid) {
      if (confirm("você realmente deseja excluir esse corretor?")) {
        CorretorService.Delete(cuuid)
          .then(() => {
            this.$buefy.toast.open({
              duration: 5000,
              message: "deleção realizado com sucesso!",
              position: "is-top-right",
              type: "is-success"
            });
          })
          .catch(() => {})
          .finally(() => {});
      }
    },
    info(id) {
      CorretorService.Info(id).then(result => {
        this.corretor = result.data;
      });
    }
  }
};
</script>
<style scoped>
.modal.is-active >>> .animation-content {
  max-width: none !important;
  width: 90%;
}
</style>